var map = {
	"./Avatar.png": 6708,
	"./Delivery, Trust, Efficiency, Speed _ Delivery, Trust, Efficiency, Speed _ Delivery, Trust, Efficiency.svg": 3452,
	"./FAQ-Image.png": 4762,
	"./Frame 36.png": 5378,
	"./Group 2.png": 9005,
	"./Pharmrun.png": 6606,
	"./RelianceHealth.png": 5128,
	"./Terminal.png": 550,
	"./agent.png": 6210,
	"./agents.png": 3282,
	"./android.svg": 6632,
	"./apple.svg": 2350,
	"./authenticationbg.png": 9604,
	"./block-img1.png.png": 8289,
	"./block-img1.svg": 1428,
	"./box1.svg": 6562,
	"./box2.svg": 5542,
	"./box3.svg": 7756,
	"./box4.svg": 1169,
	"./cardimage.png": 5510,
	"./chat1.png": 4633,
	"./chat2.png": 2805,
	"./collectionagent.png": 9155,
	"./dellyman.svg": 462,
	"./dellymanlogo.svg": 5075,
	"./div.client-img.png": 1561,
	"./div.icon (1).svg": 6549,
	"./div.icon (2).svg": 5457,
	"./div.icon.svg": 36,
	"./gig.svg": 1368,
	"./guo.svg": 1146,
	"./icon.png": 286,
	"./illustration.png": 3303,
	"./image1.png": 3115,
	"./image5.png": 6361,
	"./image6.png": 204,
	"./image7.png": 8369,
	"./image9.png": 1739,
	"./itemonland.png": 9491,
	"./itemonland2.png": 8117,
	"./mainBg.jpg": 6230,
	"./mapicon.svg": 1743,
	"./mobile-hero1.svg": 4204,
	"./new-twitter.svg": 5458,
	"./phone.svg": 5244,
	"./pseudo.png": 8528,
	"./success.png": 3513,
	"./tir-shape.svg": 8739,
	"./topship.png": 2672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;